import { useContext, useEffect } from 'react';

import { getCallDate, getCallTime } from '@Shared/helpers/callInfo';
import ConfirmationView from '@Views/shared/ConfirmationView';
import { ApplicationContext } from '@src/app/contexts/Application';
import { OfferContext } from '@src/app/contexts/Offer';
import useConversionTracking from '@src/app/hooks/useConversionTracking';
import { Offer } from '@src/app/interfaces/offer';
import EligibilityLayout from '@src/ui/layouts/EligibilityLayout';

const whatHappensNextItems = [
    'Review your quote with a qualified mortgage advisor',
    'Add supporting documents',
    'Get approved, and receive your funds',
];

const Confirmation = () => {
    const { callDateTime, applicationEmail, offers, selectedProduct } =
        useContext(ApplicationContext);

    const { selectedOffer, loading, setSelectedOffer } =
        useContext(OfferContext);

    useConversionTracking(applicationEmail, 373623);

    const date = new Date(callDateTime);

    const callDate = getCallDate(date);
    const callTime = getCallTime(date);

    const navigateLink =
        window.innerWidth >= 1024
            ? '/eligibility/offer/finalise'
            : '/eligibility/offer/book-call';

    useEffect(() => {
        if (!selectedOffer) {
            const selectedOffer =
                offers.find(
                    (offer: Offer) => offer.productCode === selectedProduct,
                ) || null;

            setSelectedOffer(selectedOffer);
        }
    }, [selectedOffer, offers, setSelectedOffer, selectedProduct]);

    const expectCall = (
        <div className='p-4 text-sm flex w-full lg:max-w-400 mb-2 items-center justify-center bg-peppermint-500 text-midnight-500 rounded-t-lg rounded-bl-lg'>
            <div className='ml-1'>
                Expect our call from:
                <span className='font-bold'> 020 4525 8044</span>
            </div>
        </div>
    );
    return (
        <EligibilityLayout
            loading={loading}
            showTrustbarV2
            stripContainerMargins
        >
            {selectedOffer ? (
                <ConfirmationView
                    navigateLink={navigateLink}
                    whatHappensNextItems={whatHappensNextItems}
                    offer={selectedOffer}
                    callDate={callDate}
                    callTime={callTime}
                    expectCall={expectCall}
                />
            ) : (
                <div></div>
            )}
        </EligibilityLayout>
    );
};

export default Confirmation;
